import { Box, Typography } from "@mui/material";
import SkillsTable from "../components/SkillsTable";
import useIsLargeScreen from "../hooks/useIsLargeScreen";

const SkillsListPage = () => {
    const isLargeScreen = useIsLargeScreen();

    return (
        <>
            <Box sx={{ marginTop: "2rem", margin: ( isLargeScreen ?  3 : 2 )}}>
                <Typography component="h1" variant="h4" gutterBottom>Insights workshop types</Typography>
                <SkillsTable />
            </Box>
        </>
    );
};

export default SkillsListPage;